module.exports = __webpack_public_path__ + "static/img/36-3.7637e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/36-3.jpg
// module id = FXKc
// module chunks = 0